import React from 'react';
import { observer } from 'mobx-react';
import ExcelLayout from '../excel-layout';
import { WeaRightMenu } from 'ecCom';
import CardStore from '../../stores/card';
import { MapAddressDialog } from '../cube-map';

export interface PreviewCardProps {
    Card: CardStore;
}

@observer
export class PreviewCard extends React.Component<PreviewCardProps, any> {
    render() {
        const { Card } = this.props;
        const {  iconInfo } = Card;
        return (
            <WeaRightMenu ecId={`${this && this.props && this.props.ecId || ''}_WeaRightMenu@e4h6wx`}   >
                <div className="cube-card-inline-wrapper cube-card-preview">
                    <div className="cube-card-inline-tab">
                        <div className="cube-card-layout">
                            {Card.isInit && [
                                <ExcelLayout ecId={`${this && this.props && this.props.ecId || ''}_ExcelLayout@a3d06r@preview`} Card={Card} />
                            ]}
                        </div>
                    </div>
                </div>
                <MapAddressDialog ecId={`${this && this.props && this.props.ecId || ''}_MapAddressDialog@pmozuf`} mapStore={Card.mapStore} iconInfo={iconInfo}/>
            </WeaRightMenu>
        )
    }
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/components/card/PreviewCard.tsx